<div *ngIf="!loading" class="container-fluid">
    <div class="row">
        <div class="col-12  y">
            <mat-spinner *ngIf="count < 2"></mat-spinner>
            <h2 *ngIf="count >= 2">No results for "{{search}}", please retry.</h2>
        </div>
    </div>
</div>

<div *ngIf="loading" class="container-fluid x">
    <div class="row">
        <div class="col-12">
            <h6>Bullet Mode</h6>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <small>ELO: {{elo}}</small>
        </div>
    </div>
    <hr>
    <div class="center row">
        <div class="col-8">
            <div style="display: block;">
                <canvas baseChart 
                  [data]="pieChartData" 
                  [labels]="pieChartLabels" 
                  [chartType]="pieChartType"
                  [colors]="chartColors"
                  [options]="pieChartOptions"
                  [plugins]="pieChartPlugins"
                  [legend]="pieChartLegend">
                </canvas>
              </div>
        </div>
    </div>
</div>
